import { useContext } from "react";
import { PoweredByAiFiBlock } from "src/views/Receipt/ReceiptDetail/blocks/PoweredByAiFiBlock";
import { MasterContext } from "src/lib/masterContext";
import styled from "styled-components";
import { ReferencePagesNavigation } from "../ReferencePagesNavigation";

export const Footer = () => {
  const {
    featureFlags: { hidePoweredByAiFi },
  } = useContext(MasterContext);

  return (
    <FooterSection>
      {!hidePoweredByAiFi && <PoweredByAiFiBlock href="https://www.aifi.com" />}
      <ReferencePagesNavigation />
    </FooterSection>
  );
};

const FooterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  gap: 16px;
`;
